import styled from 'foundations-theming/utils';
import { theme } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../../utils/usageTracker';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { View } from 'foundations-components/transitional/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Link } from 'foundations-components/transitional/components/Link';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListStyle = styled.div.withConfig({
  displayName: "PublicPageFooterMinimal__ListStyle",
  componentId: "c7b3nf-0"
})(() => ({
  ul: {
    justifyContent: 'center !important'
  }
}));
const StyledCookieSettings = styled.div.withConfig({
  displayName: "PublicPageFooterMinimal__StyledCookieSettings",
  componentId: "c7b3nf-1"
})(({
  theme: {
    color
  }
}) => ({
  a: {
    textDecoration: 'none !important',
    color: color['text-interactive-on-fill-default'],
    fontSize: '16px !important',
    '&:hover': {
      color: color['text-interactive-on-fill-hover']
    }
  }
}));
const LinkHovered = styled.div.withConfig({
  displayName: "PublicPageFooterMinimal__LinkHovered",
  componentId: "c7b3nf-2"
})(({
  theme: {
    color
  }
}) => ({
  '&:hover': {
    color: color['text-interactive-on-fill-hover']
  }
}));
const PublicPageFooterMinimal = () => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(View, {
      as: "footer",
      backgroundColor: "fill-accent-neutral-default",
      color: "text-core-on-fill-default",
      paddingBlock: "1000",
      paddingInline: "0",
      children: /*#__PURE__*/_jsxs(View, {
        inlineSize: "100%",
        marginBlock: "0",
        marginInline: "auto",
        maxInlineSize: theme.sizes.PUBLIC_PAGE_WIDTH,
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(View, {
          as: "section",
          marginBlockEnd: "400",
          typography: "body-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.publicFooter.copyRight",
            options: {
              year: new Date().getFullYear().toString()
            }
          })
        }), /*#__PURE__*/_jsx(ListStyle, {
          children: /*#__PURE__*/_jsxs(List, {
            inline: true,
            margin: "0",
            padding: "0",
            styled: false,
            children: [/*#__PURE__*/_jsx(ListItem, {
              paddingBlock: "0",
              paddingInline: "300",
              children: /*#__PURE__*/_jsx(Link, {
                href: `https://legal.hubspot.com/legal-stuff?hubs_content=${encodeURIComponent(window.location.hostname + window.location.pathname)}&hubs_content-cta=Legal+Stuff`,
                onClick: () => {
                  usageTracker.track('navInteraction', {
                    action: 'footer-legal-click'
                  });
                },
                use: "unstyled",
                children: /*#__PURE__*/_jsx(Paragraph, {
                  color: "text-interactive-on-fill-default",
                  margin: "0",
                  textAlign: "center",
                  typography: "heading-100",
                  children: /*#__PURE__*/_jsx(LinkHovered, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "academyPublic.publicFooter.legal"
                    })
                  })
                })
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              paddingBlock: "0",
              paddingInline: "300",
              children: /*#__PURE__*/_jsx(Link, {
                href: `https://legal.hubspot.com/privacy-policy?hubs_content=${encodeURIComponent(window.location.hostname + window.location.pathname)}&hubs_content-cta=Privacy+Policy`,
                onClick: () => {
                  usageTracker.track('navInteraction', {
                    action: 'footer-privacy-click'
                  });
                },
                use: "unstyled",
                children: /*#__PURE__*/_jsx(Paragraph, {
                  color: "text-interactive-on-fill-default",
                  margin: "0",
                  textAlign: "center",
                  typography: "heading-100",
                  children: /*#__PURE__*/_jsx(LinkHovered, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "academyPublic.publicFooter.privacy"
                    })
                  })
                })
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              paddingBlock: "0",
              paddingInline: "300",
              children: /*#__PURE__*/_jsx(StyledCookieSettings, {
                children: /*#__PURE__*/_jsx("span", {
                  className: "hs-footer-cookie-settings",
                  hidden: true,
                  children: /*#__PURE__*/_jsx(Link, {
                    href: "#",
                    onClick: () => {
                      usageTracker.track('navInteraction', {
                        action: 'footer-cookies-click'
                      });
                    },
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "academyPublic.publicFooter.cookies"
                    })
                  })
                })
              })
            })]
          })
        })]
      })
    })
  });
};
export default PublicPageFooterMinimal;